<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="400"
  >
      <v-card>
        <v-toolbar
          color="primary"
          dark
          dense
        >Выбор должности </v-toolbar>
        <v-card-text>
          <v-container>
            <v-autocomplete
              v-model="posID"
              :items="orgPositions"
              dense
              item-text="POS_NAME"
              item-value="IPOS_ID"
              class="mr-5"
            >
              <template v-slot:append-outer>
                <v-icon
                  color="primary"
                  @click="showAddPositionDialog"
                >mdi-circle-edit-outline</v-icon>
              </template>
            </v-autocomplete>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="$emit('input', false)"
          >Отмена</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="choosePos"
          >Сохранить</v-btn>
        </v-card-actions>
      </v-card>
      <addPositionDialog v-model="showAddPosition" @onPositionAdded="onPositionAdded" />
  </v-dialog>
</template>

<script>
import addPositionDialog from '@/components/modules/org/structure/staff/dialogs/addPositionDialog.vue'
export default {
  props: ['value', 'positionID'],
  components: {
    addPositionDialog
  },
  data () {
    return {
      locPositionID: null,
      showAddPosition: false
    }
  },
  computed: {
    posID: {
      get: function () {
        if (this.locPositionID) {
          return this.locPositionID
        } else {
          return this.positionID
        }
      },
      set: function (val) {
        this.locPositionID = val
      }
    },
    orgPositions: {
      get: function () {
        var positions = this.$store.getters.getOrgPositions
        return positions
      }
    }
  },
  methods: {
    showAddPositionDialog () {
      console.log('Called add position')
      this.showAddPosition = true
    },
    onPositionAdded (val) {
      this.showAddPosition = false
      this.$emit('onPositionAdded', val)
    },
    choosePos () {
      if (this.posID !== this.positionID) {
        this.$emit('onPositionSelected', this.posID)
      }
      this.$emit('input', false)
    }
  }
}
</script>
